export const formatFileSize = (bytes: number): string => {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
  if (bytes === 0) {
    return `${bytes} ${sizes[0]}`;
  }
  const sizeIndex = Number(Math.floor(Math.log(bytes) / Math.log(1024)));
  return `${Math.round(bytes / 1024 ** sizeIndex)} ${sizes[sizeIndex]}`;
};
